"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.serviceDataReducerSelector = exports.serviceDataReducer = exports.commonServiceSelector = exports.commonServiceDataReducers = void 0;
var _reselect = require("reselect");
var _const = require("../../../common/redux/const");
var _const2 = require("./const");
const serviceDataReducer = state => state === null || state === void 0 ? void 0 : state[_const.ASTER_CORE_REDUCER][_const2.GET_COMMON_SERVICE_DATA];
exports.serviceDataReducer = serviceDataReducer;
const commonServiceDataReducers = state => state[_const.EPHARMACY_NOT_PERSIST_REDUCER][_const2.COMMON_SERVICE_DATA];
exports.commonServiceDataReducers = commonServiceDataReducers;
const serviceDataReducerSelector = () => (0, _reselect.createSelector)(serviceDataReducer, data => {
  var _data$data;
  return (data === null || data === void 0 || (_data$data = data.data) === null || _data$data === void 0 ? void 0 : _data$data.body) || {};
});
exports.serviceDataReducerSelector = serviceDataReducerSelector;
const commonServiceSelector = () => (0, _reselect.createSelector)(commonServiceDataReducers, data => {
  return data || {};
});
exports.commonServiceSelector = commonServiceSelector;